import { render, staticRenderFns } from "./templateManagement.vue?vue&type=template&id=460f16fc&scoped=true&"
import script from "./templateManagement.vue?vue&type=script&lang=js&"
export * from "./templateManagement.vue?vue&type=script&lang=js&"
import style0 from "./templateManagement.vue?vue&type=style&index=0&id=460f16fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460f16fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('460f16fc')) {
      api.createRecord('460f16fc', component.options)
    } else {
      api.reload('460f16fc', component.options)
    }
    module.hot.accept("./templateManagement.vue?vue&type=template&id=460f16fc&scoped=true&", function () {
      api.rerender('460f16fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/templateManagement.vue"
export default component.exports